import appConfig from '../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.cnpjSpotApiEnv;

const headers = (): Record<string, string> => {
    const h: Record<string, string> = {};
    if (API_KEY) h['x-api-key'] = API_KEY;
    return h;
};

export interface CnpjSpotCompany {
    cnpj: string;
    identificador_matriz_filial: number;
    descricao_identificador_matriz_filial: string;
    razao_social: string;
    nome_fantasia: string;
    situacao_cadastral: number;
    descricao_situacao_cadastral: string;
    data_situacao_cadastral: string;
    data_inicio_atividade: string;
    cnae_fiscal: number;
    cnae_fiscal_descricao: string;
    capital_social: number;
    porte: string;
    natureza_juridica: string;
    uf: string;
    municipio: string;
    bairro: string;
    logradouro: string;
    numero: string;
    complemento: string;
    cep: string;
    ddd_telefone_1: string;
    ddd_telefone_2: string;
    email: string;
    opcao_pelo_simples: boolean;
    opcao_pelo_mei: boolean;
    qsa?: CnpjSpotPartner[];
    [key: string]: unknown;
}

export interface CnpjSpotPartner {
    nome_socio: string;
    cnpj_cpf_do_socio: string;
    qualificacao_socio: string;
    data_entrada_sociedade: string;
    identificador_de_socio: number;
    nome_representante_legal: string;
    faixa_etaria: string;
}

export interface CnpjSpotGroupResponse {
    parent_company: CnpjSpotCompany | null;
    branches: CnpjSpotCompany[];
    total: number;
}

export async function getCompanyGroup(root: string): Promise<CnpjSpotGroupResponse> {
    const cleanRoot = root.replace(/\D/g, '').substring(0, 8);
    const response = await fetch(`${API_URL}/group/${cleanRoot}`, { headers: headers() });
    if (!response.ok) {
        const err = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(err.message || `HTTP ${response.status}`);
    }
    return response.json();
}

export interface PartnerCompanyResult {
    cnpj: string;
    razao_social: string;
    nome_fantasia: string;
    descricao_situacao_cadastral: string;
    capital_social: number;
    uf: string;
    municipio: string;
    cnae_fiscal_descricao: string;
    qualificacao_socio: string;
    data_entrada_sociedade: string;
    [key: string]: unknown;
}

export async function searchPartnerCompanies(cpf: string, firstName: string): Promise<PartnerCompanyResult[]> {
    const clean = cpf.replace(/\D/g, '');
    const maskedCpf = `***${clean.slice(3, 9)}**`;
    const nameQuery = firstName.toUpperCase().trim();
    const params = new URLSearchParams({ cpf_cnpj: maskedCpf, name: nameQuery });
    const response = await fetch(`${API_URL}/partners?${params.toString()}`, { headers: headers() });
    if (!response.ok) return [];
    const json = await response.json();
    return json.data || json.items || json.results || (Array.isArray(json) ? json : []);
}
